import React from "react";
import { Row,Col,Input, AutoComplete, Card, Table, Typography, Button, Tooltip } from 'antd';
import {DownloadOutlined} from "@ant-design/icons"
import { JSONTOCSV,DownloadFile } from '../../../Settings/commonFunctions';
// import DataTable from 'react-data-table-component';
// Create Theme
export default function DataTable(props) {
    const [Search, setSearch] = React.useState(false)
    const [onDomFilter, setonDomFilter] = React.useState(props.propsTable.data)

    const handleSearchChange = e => {
        let searchString = e !== "" ? e : null
        if (searchString === null) {

            setonDomFilter(props.propsTable.data)
            return
        }
        let temp = props.propsTable.data.filter((obj) => {
            if (Object.values(obj).toString().toLowerCase().includes(searchString.toLowerCase())) return obj
        }
        )

        setonDomFilter(temp)
    }

    const handleDownload = ()=>{
        const downloadData = props.propsTable?.data.map(item=>{
            let newItem = {}
            props.propsTable?.columns.forEach(col=>{
                if(col.dataIndex && item[col.dataIndex] !== undefined){
                    newItem[col.title] = item[col.dataIndex]
                }
            })
            return newItem
        })
        DownloadFile(JSONTOCSV(downloadData),props.propsTable.downloadFileName);
    }

    let Pagination = {
        total:props.propsTable?.pagination?.total,
        showTotal:(total)=><Typography.Text className="is-center Tabletotal" >Total : {total}</Typography.Text>
    }
    if(props.propsTable?.pagination == false)Pagination = false
    


    React.useEffect(() => {
        setonDomFilter(props.propsTable.data)
    }, [props])

    return (

        <Card
            {...props.propsCard}
            extra={
                <Row gutter={[10, 10]}>
                    <Col>
                        {props.propsCard.extra}
                    </Col>
                    {props.propsTable?.downloadFile == true && 
                        <Col>
                            <Tooltip title={`Download`}><Button type="primary" ghost icon={<DownloadOutlined />} onClick={handleDownload} /></Tooltip>
                        </Col>
                    }
                    <Col>
                        <AutoComplete
                            onChange={props.propsTable.onSearching ? props.propsTable.onSearching : handleSearchChange}
                                // style={{ width: 300 }}
                             >
                            <Input.Search placeholder="Search" />
                        </AutoComplete>
                        
                    </Col>
                    <Col>
                        {
                            props.propsTable.fundsHolding && <Button onClick={props.propsTable.handleCsvDownload} className="disableBTN" disabled={props.propsTable.CSVBtnloader || props.propsTable.loading} icon={<DownloadOutlined />}>{props.propsTable.CSVBtnloader || props.propsTable.loading ? "Downloading..." : "Download CSV"}</Button>
                        }
                    </Col>
                </Row>}
        >
            <Table
                size={props.propsTable.size?props.propsTable.size:'small'}
                {...props.propsTable}
                dataSource={onDomFilter}
                pagination={Pagination}
            />
        </Card>
    )
}



// import React from "react";
// import { Row, Col, Input, AutoComplete, Card, Table, Typography, Button, Tooltip } from 'antd';
// import { DownloadOutlined } from "@ant-design/icons"
// import { JSONTOCSV, DownloadFile } from '../../../Settings/commonFunctions';

// // Resizable title component
// const ResizableTitle = (props) => {
//     const { onResize, width, ...restProps } = props;

//     if (!width) {
//         return <th {...restProps} />;
//     }

//     return (
//         <th {...restProps} style={{ position: 'relative' }}>
//             {restProps.children}
//             <div
//                 style={{
//                     position: 'absolute',
//                     right: -5,
//                     top: 0,
//                     bottom: 0,
//                     width: 10,
//                     cursor: 'col-resize',
//                     zIndex: 1,
//                 }}
//                 onMouseDown={(e) => {
//                     e.preventDefault();
//                     const startX = e.clientX;
//                     const startWidth = width;

//                     const handleMouseMove = (e) => {
//                         const newWidth = Math.max(50, startWidth + e.clientX - startX);
//                         onResize(newWidth);
//                     };

//                     const handleMouseUp = () => {
//                         document.removeEventListener('mousemove', handleMouseMove);
//                         document.removeEventListener('mouseup', handleMouseUp);
//                     };

//                     document.addEventListener('mousemove', handleMouseMove);
//                     document.addEventListener('mouseup', handleMouseUp);
//                 }}
//             />
//         </th>
//     );
// };

// export default function DataTable(props) {
//     const [Search, setSearch] = React.useState(false)
//     const [onDomFilter, setonDomFilter] = React.useState(props.propsTable.data)
    
//     // State to manage column widths
//     const [columns, setColumns] = React.useState(() => {
//         // Initialize columns with default widths if not provided
//         return props.propsTable.columns?.map(col => ({
//             ...col,
//             width: col.width || 150, // Default width if not specified
//         })) || [];
//     });

//     // Update columns when props change
//     React.useEffect(() => {
//         if (props.propsTable.columns) {
//             setColumns(props.propsTable.columns.map(col => ({
//                 ...col,
//                 width: col.width || 150,
//             })));
//         }
//     }, [props.propsTable.columns]);

//     const handleSearchChange = e => {
//         let searchString = e !== "" ? e : null
//         if (searchString === null) {
//             setonDomFilter(props.propsTable.data)
//             return
//         }
//         let temp = props.propsTable.data.filter((obj) => {
//             if (Object.values(obj).toString().toLowerCase().includes(searchString.toLowerCase())) return obj
//         }
//         )
//         setonDomFilter(temp)
//     }

//     const handleDownload = () => {
//         DownloadFile(JSONTOCSV(props.propsTable?.data), props.propsTable.downloadFileName);
//     }

//     // Calculate total table width
//     const totalTableWidth = React.useMemo(() => {
//         return columns.reduce((total, col) => total + (col.width || 150), 0);
//     }, [columns]);

//     // Handle column resize
//     const handleResize = (index) => (width) => {
//         setColumns(prevColumns => {
//             const newColumns = [...prevColumns];
//             newColumns[index] = { ...newColumns[index], width };
//             return newColumns;
//         });
//     };

//     // Create resizable columns
//     const resizableColumns = columns.map((col, index) => ({
//         ...col,
//         onHeaderCell: (column) => ({
//             width: column.width,
//             onResize: handleResize(index),
//         }),
//     }));

//     let Pagination = {
//         total: props.propsTable?.pagination?.total,
//         showTotal: (total) => <Typography.Text className="is-center Tabletotal" >Total : {total}</Typography.Text>
//     }
//     if (props.propsTable?.pagination == false) Pagination = false

//     React.useEffect(() => {
//         setonDomFilter(props.propsTable.data)
//     }, [props])

//     return (
//         <Card
//             {...props.propsCard}
//             style={{ 
//                 ...props.propsCard?.style, 
//                 overflow: 'hidden' // Ensure card doesn't break layout
//             }}
//             extra={
//                 <Row gutter={[10, 10]}>
//                     <Col>
//                         {props.propsCard.extra}
//                     </Col>
//                     {props.propsTable?.downloadFile == true &&
//                         <Col>
//                             <Tooltip title={`Download`}><Button type="primary" ghost icon={<DownloadOutlined />} onClick={handleDownload} /></Tooltip>
//                         </Col>
//                     }
//                     <Col>
//                         <AutoComplete
//                             onChange={props.propsTable.onSearching ? props.propsTable.onSearching : handleSearchChange}
//                         // style={{ width: 300 }}
//                         >
//                             <Input.Search placeholder="Search" />
//                         </AutoComplete>

//                     </Col>
//                     <Col>
//                         {
//                             props.propsTable.fundsHolding && <Button onClick={props.propsTable.handleCsvDownload} className="disableBTN" disabled={props.propsTable.CSVBtnloader || props.propsTable.loading} icon={<DownloadOutlined />}>{props.propsTable.CSVBtnloader || props.propsTable.loading ? "Downloading..." : "Download CSV"}</Button>
//                         }
//                     </Col>
//                 </Row>}
//         >
//             <Table
//                 size={props.propsTable.size ? props.propsTable.size : 'small'}
//                 {...props.propsTable}
//                 columns={resizableColumns} // Use resizable columns instead of original columns
//                 dataSource={onDomFilter}
//                 pagination={Pagination}
//                 components={{
//                     header: {
//                         cell: ResizableTitle,
//                     },
//                 }}
//                 // scroll={{ x: totalTableWidth }} // Dynamic table width based on column widths
//             />
//         </Card>
//     )
// }